export interface AdminFileGet {
    id: string;
    filename: string;
    file_url: string;
    user_id: string;
    file_type: AdminFileType;
    status: AdminFileStatus;
    uploaded_at: string;
}

export interface GasTaxGet {
    id: string;
    area: string;
    zone: string;
    tax_type: string;
    excise_tax_type_gas: string;
    taxrate_gas_scale1: number;
    taxrate_gas_scale2: number;
    taxrate_gas_scale3: number;
    taxrate_gas_scale4: number;
    rate_self_consumption: number;
    rate_transfer: number;
}

export interface DistributionTariffGasGet {
    id: string;
    td_key: string;
    year: string;
    quarter: string;
    area_gas: string;
    REMI_type_gas: string;
    gas_meter_class: string;
    gas_intensity_class: string;
    td_fixed: number;
    variable_transportation: number;
    qt_gj: number;
    var_distribution_fee_tier1: number;
    var_distribution_fee_tier2: number;
    var_distribution_fee_tier3: number;
    var_distribution_fee_tier4: number;
    var_distribution_fee_tier5: number;
    var_distribution_fee_tier6: number;
    var_distribution_fee_tier7: number;
    var_distribution_fee_tier8: number;
}

// Enums
export enum AdminFileType {
    PRICE_TABLE = 'PRICE_TABLE',
    TARIFF_TABLE_EE = 'TARIFF_TABLE_EE',
    DISTRIBUTION_TARIFF_EE = 'DISTRIBUTION_TARIFF_EE',
    DISTRIBUTION_TARIFF_GAS = 'DISTRIBUTION_TARIFF_GAS',
    TAXES_GAS = 'TAXES_GAS',
    ACCISE_GAS = "ACCISE_GAS",
    ATECO_CURVES = "ATECO_CURVES",
    CURVE_DATA = "CURVE_DATA"
}

export enum AdminFileStatus {
    UPLOADED = 'UPLOADED',
    PROCESSING = 'PROCESSING',
    PROCESSED = 'PROCESSED',
    FAILED = 'FAILED',
}